import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=770e9c7e&scoped=true"
import script from "./CommonForm.vue?vue&type=script&lang=js"
export * from "./CommonForm.vue?vue&type=script&lang=js"
import style0 from "./CommonForm.vue?vue&type=style&index=0&id=770e9c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770e9c7e",
  null
  
)

export default component.exports